import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69734a421beda80014f430ec/omnix_ai_platform/src/app/ai-categories/components/AICategoriesInteractive.tsx");
